import { Object3D } from "three";
import { MeshInfo } from "../../Meshes/MeshInfo";

export class PlinthObject extends Object3D {

    public MeshInfo?: MeshInfo;

    constructor() {
        super();
    }
}